// extracted by mini-css-extract-plugin
export default {"container":"AnnouncementMedia_container__iWOv0","image":"AnnouncementMedia_image__quhMy"};